jQuery(function($) {

/*///////////////////////////////////////

>>  ANIMATIONS
>>  SPECIFICS - page load, screen sizes, on scroll, etc
>>  POP UPS, MODALS, ALERT,  ETC
>>  HEADER
>>  TABLES
>>  SECTIONS
>>  SLICK SLIDERS
>>  MAPS

///////////////////////////////////////*/

/*///////////////////////////////////////
>>  ANIMATIONS
///////////////////////////////////////*/

// add animation class and css on scroll - global
function isScrolledIntoView(elem) {
var docViewTop = $(window).scrollTop();
var docViewBottom = docViewTop + $(window).height();
var docViewHeight = .25 * $(window).height();
var elemTop = $(elem).offset().top;
var elemIndex = elemTop + docViewHeight;
//var elemBottom = elemTop + $(elem).height();
return ((elemIndex <= docViewBottom));
}

function revealOnScroll() {
if ($(window).width() > 767) {
  var scrolled = $(window).scrollTop();
  $('.fade').each(function() {
    var current = $(this), 
    w_height = $(window).outerHeight(), 
    offsetTop = current.offset().top; 
    // this commented out bit was original where animation happened every time you scroll, not just on load
    // if (scrolled + w_height - 50 > offsetTop) {
    //   current.addClass("animation");
    // } else {
    //   current.removeClass("animation");
    // }
    if (isScrolledIntoView(this) === true) {
      current.addClass('animation');
    }
  });
  // stagger some elements
  $('.stagger').each(function() {
    var current = $(this);
    if (isScrolledIntoView(this) === true) {
    	var allItems = current.find('.col').add(current.children('.button'));
      allItems.each(function(i) {
        var item = $(this);
        setTimeout(function() {
          item.addClass('animation');
        }, 200*i);
        // each element should receive the class 200ms after the last one
      });
    }
  });
}
}
revealOnScroll();

/*///////////////////////////////////////
>>  SPECIFICS
///////////////////////////////////////*/

//** things that happen after page load **//
$( document ).ready(function() {

});// end page load

//** things that happen on scroll **//
$(document).scroll(function () {

	if($(window).scrollTop() > 0) {
		$('.top-bar').addClass('scrolled');
	} else {
    $('.top-bar').removeClass('scrolled');
  }

	//animations
	revealOnScroll();

	//parallax elements on scroll
	var parallaxElement = $('.parallax'),
		parallaxQuantity = parallaxElement.length;
	window.requestAnimationFrame(function() {
		if ($(window).width() > 750) {
			for (var i = 0; i < parallaxQuantity; i++) {
				var currentElement = parallaxElement.eq(i),
					windowTop = $(window).scrollTop(),
					elementTop = currentElement.offset().top,
					elementHeight = currentElement.height(),
					viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.2,
					scrolled = windowTop - elementTop + viewPortHeight;
				if ( $(currentElement).is( '.reverse' ) ) {
					currentElement.css({
						transform: 'translate3d(0,' + scrolled * +0.1 + 'px, 0)'
					});
				} else {
					currentElement.css({
						transform: 'translate3d(0,' + scrolled * -0.1 + 'px, 0)'
					});
				}
			}
		}
	});
});// end on scroll


/*///////////////////////////////////////
>>  POP UPS, MODALS, ALERT,  ETC
///////////////////////////////////////*/


/*///////////////////////////////////////
>>  HEADER
///////////////////////////////////////*/

$('.menu-icon').click(function(){
	$('.top-bar,body').toggleClass('mobile-open');
});

/*///////////////////////////////////////
>>  TABLES
///////////////////////////////////////*/


/*///////////////////////////////////////
>>  SECTIONS
///////////////////////////////////////*/


/*///////////////////////////////////////
>>  SLICK SLIDERS
///////////////////////////////////////*/

$('.review-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  prevArrow: '<svg class="slick-arrow prev" width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.585938 12.5873C-0.195312 13.3686 -0.195312 14.6373 0.585938 15.4186L12.5859 27.4186C13.3672 28.1998 14.6359 28.1998 15.4172 27.4186C16.1984 26.6373 16.1984 25.3686 15.4172 24.5873L4.82969 13.9998L15.4109 3.4123C16.1922 2.63105 16.1922 1.3623 15.4109 0.581055C14.6297 -0.200195 13.3609 -0.200195 12.5797 0.581055L0.579688 12.5811L0.585938 12.5873Z" fill="black"/><path d="M0.585938 12.5873C-0.195312 13.3686 -0.195312 14.6373 0.585938 15.4186L12.5859 27.4186C13.3672 28.1998 14.6359 28.1998 15.4172 27.4186C16.1984 26.6373 16.1984 25.3686 15.4172 24.5873L4.82969 13.9998L15.4109 3.4123C16.1922 2.63105 16.1922 1.3623 15.4109 0.581055C14.6297 -0.200195 13.3609 -0.200195 12.5797 0.581055L0.579688 12.5811L0.585938 12.5873Z" fill="black" fill-opacity="0.2"/><path d="M0.585938 12.5873C-0.195312 13.3686 -0.195312 14.6373 0.585938 15.4186L12.5859 27.4186C13.3672 28.1998 14.6359 28.1998 15.4172 27.4186C16.1984 26.6373 16.1984 25.3686 15.4172 24.5873L4.82969 13.9998L15.4109 3.4123C16.1922 2.63105 16.1922 1.3623 15.4109 0.581055C14.6297 -0.200195 13.3609 -0.200195 12.5797 0.581055L0.579688 12.5811L0.585938 12.5873Z" fill="black" fill-opacity="0.2"/></svg>',
  nextArrow: '<svg class="slick-arrow next" width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4143 12.5873C16.1955 13.3686 16.1955 14.6373 15.4143 15.4186L3.41426 27.4186C2.63301 28.1998 1.36426 28.1998 0.583008 27.4186C-0.198242 26.6373 -0.198242 25.3686 0.583008 24.5873L11.1705 13.9998L0.589258 3.4123C-0.191992 2.63105 -0.191992 1.3623 0.589258 0.581055C1.37051 -0.200195 2.63926 -0.200195 3.42051 0.581055L15.4205 12.5811L15.4143 12.5873Z" fill="black"/><path d="M15.4143 12.5873C16.1955 13.3686 16.1955 14.6373 15.4143 15.4186L3.41426 27.4186C2.63301 28.1998 1.36426 28.1998 0.583008 27.4186C-0.198242 26.6373 -0.198242 25.3686 0.583008 24.5873L11.1705 13.9998L0.589258 3.4123C-0.191992 2.63105 -0.191992 1.3623 0.589258 0.581055C1.37051 -0.200195 2.63926 -0.200195 3.42051 0.581055L15.4205 12.5811L15.4143 12.5873Z" fill="black" fill-opacity="0.2"/><path d="M15.4143 12.5873C16.1955 13.3686 16.1955 14.6373 15.4143 15.4186L3.41426 27.4186C2.63301 28.1998 1.36426 28.1998 0.583008 27.4186C-0.198242 26.6373 -0.198242 25.3686 0.583008 24.5873L11.1705 13.9998L0.589258 3.4123C-0.191992 2.63105 -0.191992 1.3623 0.589258 0.581055C1.37051 -0.200195 2.63926 -0.200195 3.42051 0.581055L15.4205 12.5811L15.4143 12.5873Z" fill="black" fill-opacity="0.2"/></svg>'
});

/*///////////////////////////////////////
>>  MAPS
///////////////////////////////////////*/



});